import { render, staticRenderFns } from "./editluarnegeri.vue?vue&type=template&id=eb19581a&"
import script from "./editluarnegeri.vue?vue&type=script&lang=js&"
export * from "./editluarnegeri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports